import type { ProLayoutProps } from '@ant-design/pro-components';

const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  colorPrimary: '#1677ff',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  colorWeak: false,
  title: 'Stockware',
  pwa: false,
  // logo 不在此写死（避免 public 固定名缓存）：运行时由 src/app.tsx 的 layout 用带 hash 的 import 资源提供
  iconfontUrl: '',
  token: {},
};

export default Settings;
